export default "__VITE_ASSET__13dc2733__"